import React, { useRef } from 'react';

const Modal = ({
  closeModal,
  tooltip,
  title = Drupal.t('More Information'),
}) => {
  const modalBody = useRef();

  return (
    <>
      <div
        className="fixed z-overlay inset-0"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
        onClick={(e) => {
          if (modalBody.current && (e.target === modalBody.current || e.target === modalBody.current.parentElement)) {
            closeModal();
          }
        }}
      >
        <div ref={modalBody}
             className="flex items-end justify-center text-center laptop:pt-5xl">
          <div
            className="relative inline-block align-top text-left overflow-hidden shadow w-full max-w-4xl laptop:w-11/12 laptop:h-5/6 h-screen laptop:max-h-[calc(100vh-5rem)]"
          >
            <div
              className="sticky top-0 h-[55px] flex items-center justify-between bg-brand-1 pl-2xl pr-sm"
            >
              <div
                className="font-semibold text-base text-white">{title}</div>
              <ft-button ghost="" icon="" onClick={() => closeModal()}
                         type="button">
                <ft-icon color="white" name="close" width="24"></ft-icon>
                <span slot="a11y">Close</span>
              </ft-button>
            </div>
            <div
              className="bg-white h-screen tablet:h-auto w-full p-xl overflow-y-scroll tablet:overflow-y-auto overflow-x-hidden max-h-[calc(100vh-3rem)] tablet:max-h-[calc(100vh-9rem)]">
              <div className="tooltip-wrapper" dangerouslySetInnerHTML={{
                __html: tooltip,
              }}>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ft-backdrop dropped="" color="black"
                   onClick={() => closeModal()}></ft-backdrop>
    </>
  );
};

export default Modal;
